import FormControl from "@mui/material/FormControl";
import {Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";


export const SelectModel = ({ selectedModel, onSelect, interactionModels }) => {
    return (
        <div className="select-model">
            <FormControl sx={{ m: 1 }}>
                <Select
                    displayEmpty
                    value={selectedModel}
                    sx={{
                        height: 32,
                        minWidth: 316,
                        maxWidth: 316,
                        "& .MuiSelect-select": {
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                            paddingRight: "32px"
                        },
                        "& .MuiOutlinedInput-input": {
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={onSelect}
                    renderValue={(selected) => (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "100%"
                        }}>
                            {selected?.ProcedureName || "selected"}
                        </div>
                    )}
                >
                    {Array.from(interactionModels.values()).map((model) => (
                        <MenuItem
                            key={model.ProcedureIdentifier}
                            value={model}
                            sx={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%",
                                padding: "6px 16px"
                            }}
                        >
                            {model.ProcedureName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};